import axios from 'axios'
import { normalize } from 'normalizr'
import queryString from 'query-string'

import { userSchema, agendaSchema, appointmentSchema, reportSchemaCreator } from './schema'

// Url based on environment
const http = axios.create({
  baseURL: //process.env.NODE_ENV === 'production' ? 
  'https://virtualclinwebapi.azurewebsites.net', //: 
  //'https://virtualclinwebapi-staging.azurewebsites.net',
  timeout: 45000,
})

const api = {
  logIn: ({ username, password }) => {
    return http.post('/oauth/token',
    queryString.stringify({ username, password, grant_type: 'password' }),
    { headers: { 'Content-Type': 'application/x-www-form-urlencoded' }})
  },
  getUser: () => http.get('/api/account/user').then(res => normalize(res.data, userSchema)),
  getAgendas: () => http.get('/api/user/agendas').then(res => normalize(res.data, [agendaSchema])),
  getAgendaReport: ({ id, year, month }) => http.get(`/api/professionalappointments/agenda/${id}/report?month=${month}&year=${year}`).then(res => normalize(res.data, reportSchemaCreator(id, year, month))),
  getAgendaWeekAppointments: ({ id, day, month, year }) => http.get(`/api/appointments/agenda/${id}?weekOrDatetime=datetime_search&initialDateDay=${day}&initialDateMonth=${month}&initialDateYear=${year}&InitialDateMinutes=0&IntervalMinutes=10080`).then(res => normalize(res.data, [appointmentSchema])),
  createAppointment: ({ id, year, month, day, minutes }) => http.post(`/api/appointment/agenda/${id}/createappointment`, { appointmentDateYear: year, appointmentDateMonth: month, appointmentDateDay: day, appointmentDateMinutes: minutes }).then(res => normalize(res.data, appointmentSchema)),
  closeAppointment: ({ id }) => http.put(`/api/appointment/${id}/close`, { extraNote: '' }).then(res => normalize(res.data, appointmentSchema)),
  closeAllAppointmentsForDay: ({ id, year, month, day }) => http.put(`/api/appointments/agenda/${id}/close`, { appointmentsToCloseDateYear: year, appointmentsToCloseDateMonth: month, appointmentsToCloseDateDay: day, appointmentsToCloseInitialDateMinutes: 0, appointmentsToCloseIntervalMinutes: 1440 }).then(res => normalize(res.data, [appointmentSchema])),
  openAppointment: ({ id }) => http.put(`/api/appointment/${id}/open`, { extraNote: '' }).then(res => normalize(res.data, appointmentSchema)),
  completeAppointment: ({ id }) => http.put(`/api/appointment/${id}/complete`).then(res => normalize(res.data, appointmentSchema)),
  cancelAppointment: ({ id, extraNote }) => http.put(`/api/appointment/${id}/professionalcancel`, { CancellationExtraNote: extraNote }).then(res => normalize(res.data, appointmentSchema)),
  getTeleHealthAppointmentCredentials: appointmentId => http.get(`/api/telehealth/appointment/${appointmentId}/credentials`),
}

export { http }
export default api



// WEBPACK FOOTER //
// ./src/lib/api.js